export enum StatusQuestionario {
    daCompletare = 'ASSEGNATO',
    completato = 'COMPLETATO',
    daAttivare = 'DA_ATTIVARE'
}